angular.module("acl.common.resizeListener", []);
